import React from 'react';
import LogViewer from '../../../components/LogViewer';

interface LogTabProps {
  selectedPortfolio?: {
    id: string;
    portfolioId: string;
    portfolioName: string;
  } | null;
  strategyId?: string | null;
  executionId?: string | null;
  compact?: boolean;
  refreshKey?: number;
}

const LogTab: React.FC<LogTabProps> = ({ selectedPortfolio, strategyId, executionId, compact = false, refreshKey }) => {
  return (
    <LogViewer
      selectedPortfolio={selectedPortfolio}
      strategyId={strategyId}
      strategyType="GRID"
      executionId={executionId}
      compact={compact}
      showExecutionControls={!compact}
      refreshKey={refreshKey}
    />
  );
};

export default LogTab;
